/*
 * @Description: 底部弹出框（show-是否弹出，onClose-关闭回调，maskMode-是否半透明背景，title-标题）
 * @Author: 蔺晨
 * @Date: 2020-07-23 17:45:08
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2020-12-01 17:33:05
 */

import React, { Component, Fragment } from 'react';
import { Flex, Toast, Modal } from 'antd-mobile';
import './index.less';
import Util from 'utils';
import cx from 'classnames';
import { inject, observer } from 'mobx-react';

@observer
export default class PopupBoxView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  renderLine = () => {
    const { onClose } = this.props;
    return <div onClick={(e) => onClose && onClose(e)} className="line"></div>;
  };

  render() {
    const { hiddenClose, show, onClose, maskMode = true, title = '', className = '' } = this.props;
    return (
      <Fragment>
        {show && maskMode ? (
          <div className="popup-mask" onClick={(e) => onClose && onClose(e)} />
        ) : (
          ''
        )}
        <div className={cx('popup-box', { show }, className)}>
          <Flex className="popup-header">
            <Flex.Item>{title}</Flex.Item>
            {!hiddenClose && (
              <i className="iconfont icon-dialog_guanbi" onClick={() => onClose && onClose()} />
            )}
            {hiddenClose && this.renderLine()}
          </Flex>
          <div className="popup-body" style={this.props.style || {}}>
            {this.props.children}
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/PopupBox/index.js